
import "C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/settings/styles/settings/header-actions-render.less?modules";
export default {"header-actions-render-icon": `header-actions-render-icon-6RsDRbJg`}
